import { updateDefaultSeoTitle } from '@utils/entity-defaults';
export { updateDefaultSeoTitle };
const _transformContentBlocksToSeoDescription = (contentsRef) => {
    const firstTextBlock = contentsRef.find((block) => block.type === 'TEXT');
    if (firstTextBlock) {
        const blockContentWithoutTags = firstTextBlock.content.replace(/(<([^>]+)>)/gi, '').replaceAll('&nbsp;', ' ');
        if (blockContentWithoutTags) {
            return blockContentWithoutTags.substring(0, 150);
        }
    }
    return '';
};
export const getDefaultSeoDescription = (content) => {
    if (content.leadText?.trim()) {
        return content.leadText;
    }
    const fromTextBlocks = _transformContentBlocksToSeoDescription(content.contentsRef);
    if (fromTextBlocks) {
        return fromTextBlocks;
    }
    return content.title;
};
export const hasCustomSeoDescription = (content) => content && content.seoDescription
    ? !!content.seoDescription.trim() && content.seoDescription !== getDefaultSeoDescription(content)
    : false;
export const updateDefaultSeoDescription = (content, previousContent) => {
    if (!hasCustomSeoDescription(content) ||
        (previousContent && !hasCustomSeoDescription(previousContent) && previousContent.seoDescription === content.seoDescription)) {
        content.seoDescription = getDefaultSeoDescription(content);
    }
};
//# sourceMappingURL=seo.defaults.js.map